export default "__VITE_ASSET__e493699e__"